import React, { useState } from 'react';
import { Header } from './components/Header';
import { Sidebar } from './components/Sidebar';
import { AssessmentContent } from './components/AssessmentContent';
import { AnalyticsDashboard } from './components/AnalyticsDashboard';
import { FeedbackPage } from './components/FeedbackPage';
import { AdminHub } from './pages/AdminHub';
import { ReportsPage } from './pages/ReportsPage';
import { UserManagementPage } from './pages/UserManagementPage';
import { ProfilePage } from './pages/ProfilePage';
import { SettingsPage } from './pages/SettingsPage';
import { AlertsPage } from './pages/AlertsPage';
import { BulkUploadResultsPage } from './pages/BulkUploadResultsPage';
import { Routes, Route, Navigate, BrowserRouter } from 'react-router-dom';
function App() {
  return <BrowserRouter data-id="element-0">
      <div className="flex h-screen bg-gray-50" data-id="element-1">
        <Sidebar data-id="element-2" />
        <div className="flex-1 flex flex-col overflow-hidden" data-id="element-3">
          <Header data-id="element-4" />
          <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-50" data-id="element-5">
            <Routes data-id="element-6">
              <Route path="/" element={<Navigate to="/admin" replace data-id="element-8" />} data-id="element-7" />
              <Route path="/admin" element={<AdminHub data-id="element-10" />} data-id="element-9" />
              <Route path="/analytics" element={<AnalyticsDashboard data-id="element-12" />} data-id="element-11" />
              <Route path="/assessment" element={<UserManagementPage data-id="element-14" />} data-id="element-13" />
              <Route path="/feedback" element={<ReportsPage data-id="element-16" />} data-id="element-15" />
              <Route path="/profile" element={<ProfilePage data-id="element-18" />} data-id="element-17" />
              <Route path="/settings" element={<SettingsPage data-id="element-20" />} data-id="element-19" />
              <Route path="/alerts" element={<AlertsPage data-id="element-22" />} data-id="element-21" />
              <Route path="/bulk-upload-results" element={<BulkUploadResultsPage data-id="element-24" />} data-id="element-23" />
            </Routes>
          </main>
        </div>
      </div>
    </BrowserRouter>;
}
export { App };